import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import Styled from 'styled-components';
import gql from 'graphql-tag';
import { Box } from '@components/layout/Grid';
import SurveyModalHook from '@organisms/modals/SurveyModalHook';
import { Trans } from '@lingui/react';

const SURVEY_QUERY = gql`
  query($programSlug: String!, $kind: String!) {
    programSurveyCompletion(
      genericProgramSlug: $programSlug
      programSurveyKind: $kind
    ) {
      programSurveyId
    }
  }
`;

const Wrapper = Styled.div`
  min-height: 60vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  background-color: #E3F4FE;
`;

const QuizIcon = Styled.img`
  height: 62px;
  width: 56px;
  margin-right: -15px;
  margin-bottom: 30px;
`;

const Title = Styled.p`
  font-size: 20px;
  font-weight: 300;
  line-height: 17px;
  margin: 0 0 20px 0;
`;

const DescriptionText = Styled.p`
  max-width: 650px;
  font-size: 14px;
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
`;

const Openbutton = Styled.button`
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 3px;
  padding: 12px 20px;
  margin-top: 10px;
  background-color: ${({ theme }) => theme.colors.primary['blue-2']};
  ${({ disabled }) =>
    disabled ? 'pointer-event: none; opacity: .8;' : 'cursor: pointer;'}
`;

let timeoutId;
const SurveyOverlay = ({ survey, user_id, program_slug, onComplete }) => {
  const [isPolling, setIsPolling] = useState(false);
  const [
    SurveyModal,
    { isOpen: isModelOpen, openModal, closeModal },
  ] = SurveyModalHook({
    data: { survey, user_id, program_slug },
    open: false,
    onComplete() {
      // called after mutation respond
      // we should send a notification up to refresh the program query
      // then close
      closeModal();
    },
  });

  const [loadSurveyStatus, { data: response, stopPolling }] = useLazyQuery(
    SURVEY_QUERY,
    {
      variables: {
        programSlug: program_slug,
        kind: survey?.kind,
      },
      fetchPolicy: 'network-only',
      pollInterval: 1000,
    }
  );

  useEffect(() => {
    if (response?.programSurveyCompletion?.programSurveyId) {
      stopPolling?.();
      onComplete?.();
      setIsPolling(false);
      clearTimeout(timeoutId);
    }

    return () => {
      // will there be an error if we do not clean this ?
      // and simply refresh program query ???
      stopPolling?.();
      clearTimeout(timeoutId);
    };
  }, [response?.programSurveyCompletion?.programSurveyId]);

  useEffect(() => {
    if (isModelOpen) {
      setIsPolling(true);
      loadSurveyStatus();
      timeoutId = setTimeout(
        () => {
          // call it and show an error of not being able to confirm submittion?
          // but we do not know if the user submitted!!!
          stopPolling?.();
        },
        // 1 minute
        60000
      );
    }
  }, [isModelOpen]);

  let title, description;
  if (survey.kind === 'pre') {
    title = <Trans id="phasedProgram.survey.pre.title" />;
    description = <Trans id="phasedProgram.survey.pre.description" />;
    // if (survey.finished) {
    //   description = (
    //     <Trans id="phasedProgram.survey_finished.pre.description" />
    //   );
    // }
  } else if (survey.kind === 'post') {
    title = <Trans id="phasedProgram.survey.post.title" />;
    description = <Trans id="phasedProgram.survey.post.description" />;
    // if (survey.finished) {
    //   description = (
    //     <Trans id="phasedProgram.survey_finished.post.description" />
    //   );
    // }
  }

  function renderButton() {
    let button_text;
    if (survey.kind === 'pre') {
      button_text = <Trans id="phasedProgram.survey.pre.start_button" />;
    } else if (survey.kind === 'post') {
      button_text = <Trans id="phasedProgram.survey.post.start_button" />;
    }
    return (
      <Openbutton onClick={openModal} disabled={isPolling && isModelOpen}>
        {isPolling && isModelOpen ? 'waiting...' : button_text}
      </Openbutton>
    );
    // if (!isPolling) {
    // } else {
    //   return 'Waiting for confirmation from service..';
    // }
  }

  return survey?.id ? (
    <>
      <Box mb="50px">
        <Wrapper>
          <QuizIcon src="/static/icons/quiz-illustration.svg" alt="quiz icon" />
          <Title>{title}</Title>
          <DescriptionText>{description}</DescriptionText>
          {!survey.finished && !survey.locked ? renderButton() : null}
        </Wrapper>
      </Box>
      {SurveyModal}
    </>
  ) : null;
};

export default SurveyOverlay;
